"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const react_intl_1 = require("react-intl");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const react_redux_1 = require("react-redux");
const actions_1 = __importDefault(require("@src/actions"));
const premium_subscription_1 = require("@src/helpers/premium-subscription");
const types_1 = require("@src/types");
const DeletePaymentMethodModal = ({ setIsDeletePaymentMethodModalOpen, isDeletePaymentMethodModalOpen }) => {
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { companyInfo: company } = (0, admin_context_1.useAdminContextValue)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { mutateAsync: deletePaymentMethod, isLoading: isDeletingPaymentMethod } = (0, useAppMutation_1.useAppMutation)(Api.Admin.deletePaymentMethod);
    const { mutateAsync: deleteLinkedScheduledJobsToPaymentSubscription, isLoading: isDeletingLinkedScheduledJobs } = (0, useAppMutation_1.useAppMutation)(Api.ScheduledJob.deleteLinkedScheduledJobsToPaymentSubscription);
    const activePremiumSubscription = (0, premium_subscription_1.getCompanyActivePremiumCompanyProfileSubscription)(company.companyPaymentSubscriptions);
    const hasActiveSubscriptionScheduledJobs = Boolean(activePremiumSubscription === null || activePremiumSubscription === void 0 ? void 0 : activePremiumSubscription.scheduledJobs.some(({ deletedAt, triggerStartAt, companyPaymentSubscriptionId, jobType }) => !deletedAt &&
        !triggerStartAt &&
        companyPaymentSubscriptionId === activePremiumSubscription.id &&
        types_1.ScheduledJobType.deactivateCompanyPremiumFeatures !== jobType));
    const hasCurrentlyActiveSubscriptionAndHasScheduledJobsForActiveSubscription = activePremiumSubscription && hasActiveSubscriptionScheduledJobs;
    const deleteCard = async () => {
        try {
            await deletePaymentMethod();
            if (activePremiumSubscription) {
                await deleteLinkedScheduledJobsToPaymentSubscription({
                    companyPaymentSubscriptionId: activePremiumSubscription.id,
                });
            }
            queryClient.invalidateQueries(queries_1.Queries.getPaymentMethods);
            dispatch(actions_1.default.myCompanyInfoInitStart());
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
            setIsDeletePaymentMethodModalOpen(false);
        }
        catch (err) {
            console.error(err);
        }
    };
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { centered: true, visible: isDeletePaymentMethodModalOpen, onCancel: () => {
            setIsDeletePaymentMethodModalOpen(false);
        }, confirmLoading: isDeletingPaymentMethod || isDeletingLinkedScheduledJobs, onOk: deleteCard, okText: intl.formatMessage({ id: 'admin.payments.delete_payment_method' }), okType: "danger", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: hasCurrentlyActiveSubscriptionAndHasScheduledJobsForActiveSubscription
                ? 'admin.payments.payment_methods.are_you_sure_remove_card_and_subscription'
                : 'admin.payments.payment_methods.are_you_sure_remove_card' }) }));
};
exports.default = DeletePaymentMethodModal;
